export default __webpack_public_path__ + "static/media/Privacy_Icon.fb6dfd6e.svg";